import "../TextBlock/textblock.scss";
import "./faq-block.scss";